module.exports = __webpack_public_path__ + "img/2.93ad6b98.jpg";